module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g9ll7"))).then(() => parcelRequire('hEqeo'));